import script from "./Viplist.vue?vue&type=script&setup=true&lang=js"
export * from "./Viplist.vue?vue&type=script&setup=true&lang=js"

import "./Viplist.vue?vue&type=style&index=0&id=53594731&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53594731"]])

export default __exports__